import axios from 'axios';
import authHeader from '../auth-header';
import { API_URL } from '../API_URL';

class DormsServices{

    GetAllDormsRoomCategories(GenderID){
        return axios.get(API_URL + `DormsReservation/GetAllDormsRoomCategories?GenderID=${GenderID}`,
            { headers: authHeader() } )            
      }
      GetAll_DormsRoomResrvationPeriod(){
        return axios.get(API_URL + `DormsReservation/GetAll_DormsRoomResrvationPeriod`,
        { headers: authHeader() } )   
      }
      GetAll_ReservationPriceAndAvailableRooms(RoomCategoryID , ReservationPeriodID){
        return axios.get(API_URL + `DormsReservation/GetAll_ReservationPriceAndAvailableRooms?RoomCategoryID=${RoomCategoryID}&ReservationPeriodID=${ReservationPeriodID}`,
        { headers: authHeader() } )   
      }
      confirm(ConfirmObj){
        return axios.post(API_URL + `DormsReservation/DormsReservation_ReserveMethod?UserID=${ConfirmObj.UserID}&ApplicantID=${ConfirmObj.ApplicantID}&Price=${ConfirmObj.Price}&GracePeriod=${ConfirmObj.GracePeriod}`,
        {
          
           PersonCategoryID: ConfirmObj.PersonCategoryID,
           PersonCode: ConfirmObj.PersonCode,
           PersonName: ConfirmObj.PersonName,
           RoomReservationID: ConfirmObj.RoomReservationID
        },
        { headers: authHeader() } )   
      }

      ReservationInfo(PersonCode)
      {
        return axios.get(API_URL + `DormsReservation/GetAll_ReservationForPerson?PersonCode=${PersonCode}`,
        
        { headers: authHeader() } ) 

      }

      CancelReservation(PersonReservationId,UserId)
      {
        return axios.post(API_URL + `DormsReservation/DormsReservation_CancelReservation?ReservationID=${PersonReservationId}&UserID=${UserId}`,
        
        { headers: authHeader() } ) 

      }



}
export default new DormsServices();